import { SocialService } from "./enums";

/**
 * Returns the public profile URL for a given social service and handle.
 * Handles all supported SocialService values.
 *
 * @example
 * getSocialProfileUrl("tiktok", "@user") // "https://www.tiktok.com/@user"
 * getSocialProfileUrl("instagram", "user") // "https://www.instagram.com/user"
 */
export const getSocialProfileUrl = (
  service: SocialService,
  handle: string,
): string => {
  const cleanHandle = handle.trim().replace(/^@+/, "");
  switch (service) {
    case "tiktok":
      return `https://www.tiktok.com/@${cleanHandle}`;
    case "instagram":
      return `https://www.instagram.com/${cleanHandle}`;
    case "youtube":
      return `https://www.youtube.com/@${cleanHandle}`;
    case "twitter":
      return `https://twitter.com/${cleanHandle}`;
    case "facebook":
      return `https://www.facebook.com/${cleanHandle}`;
    case "snapchat":
      return `https://www.snapchat.com/add/${cleanHandle}`;
    case "cameo":
      return `https://www.cameo.com/${cleanHandle}`;
    case "twitch":
      return `https://www.twitch.tv/${cleanHandle}`;
    default:
      return cleanHandle;
  }
};
